import api from "./api";
import { PaginatedResponse } from "@/types/borrower";

export interface Underwriter {
  id: number;
  email: string;
  first_name?: string;
  last_name?: string;
  name?: string;
  organization_names?: string[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

/** Read-only list for picking an underwriter; managing users lives in `services/users`. */
export const underwriterService = {
  list: async (
    params: { page?: number; search?: string } = {}
  ): Promise<PaginatedResponse<Underwriter>> => {
    const response = await api.get<PaginatedResponse<Underwriter>>("/accounts/underwriters/", {
      params,
    });
    return response.data;
  },
};
